const constants = require('@/util/constants')
require('./config')

/**
 * 获取所有角色
 */
export function getRoles (successcb, failedcb) {
  axios.get('/visitor/api/roles', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取省市
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getRegions (successcb, failedcb) {
  axios.get('/api/region/get', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
